import { createAction, handleActions } from 'redux-actions';

/* eslint-disable camelcase */
export interface ProductAnalyticsResponse {
  enabled: boolean
  domain: string
  app_id: string
  login_app_id: string
  data_layer: {
    data_center_domain: string
    organization: string
    organization_id: string
    migrated: number
    origin_partner: string
  }[]
}
/* eslint-enable camelcase */

export type ProductAnalyticsState = {
  isLoading: boolean
  failed: boolean
  dataLayer: {
    organization: ''
    organizationId: ''
    dataCenterDomain: ''
  }
} | {
  isLoading: false
  failed: false
  dataLayer: {
    organization: string
    organizationId: string
    dataCenterDomain: string
  }
} | {
  isLoading: false
  failed: true
  dataLayer: null
}

const initialState: ProductAnalyticsState = {
  isLoading: true,
  failed: false,
  dataLayer: {
    organization: '',
    organizationId: '',
    dataCenterDomain: '',
  },
};

export const fetchOrganizationProductAnalyticsInitialized = createAction(
  '@platform/query/organization/getProductAnalytics/init',
);
export const fetchOrganizationProductAnalyticsSucceeded = createAction(
  '@platform/query/organization/getProductAnalytics/success',
  (payload: any) => payload,
);
export const fetchOrganizationProductAnalyticsFailed = createAction(
  '@platform/query/organization/getProductAnalytics/failed',
);

export default handleActions<ProductAnalyticsState, ProductAnalyticsResponse>({
  [fetchOrganizationProductAnalyticsInitialized.toString()]: state => ({
    ...state,
    isLoading: true,
    failed: false,
    dataLayer: {
      organization: '',
      organizationId: '',
      dataCenterDomain: '',
    },
  }),
  [fetchOrganizationProductAnalyticsSucceeded.toString()]: (state, { payload }) => ({
    ...state,
    isLoading: false,
    failed: false,
    dataLayer: {
      organization: payload.data_layer[0].organization,
      organizationId: payload.data_layer[0].organization_id,
      dataCenterDomain: payload.data_layer[0].data_center_domain,
    },
  }),
  [fetchOrganizationProductAnalyticsFailed.toString()]: state => ({
    ...state,
    isLoading: false,
    failed: true,
    dataLayer: null,
  }),
}, initialState);
